// Bootstrap first
import "./bootstrap";

import { Initializer } from "modules/Initializer";

Initializer.init();